import React from 'react'
import { ListItem } from 'Lib/List'
import { Truncate } from 'Lib/Text'
import { CLEVERTAP_EVENT_NAME } from 'AccountsConstants/clevertap'
import {
  // isPastTrip,
  formatTripName,
  triggerClevertap,
  getCommonClevertapParams,
  convertToSafariCompatibleDate,
  getStatusBgClass,
  showTrackerText
  // getDateFormat
} from 'AccountsUtils'
import CalendarIcon from './CalendarIcon'
import TripTypeIcon from './TripTypeIcon'
import './TripListDesktopItem.css'
import { getMappedValue } from '../../../../utils/arabicUtils'

const TripsListDesktopItem = ({ tripDetails, loader }) => {
  const {
    travelDate,
    tripName,
    tripId,
    tripType,
    bookingDate,
    travellers,
    bookingStatus,
    sourceType
  } = tripDetails
  let detailsLink
  if (sourceType === 'old flyin') {
    detailsLink = `/accounts/trips/${tripId}?recordType=${tripType}&chnl=Fly`
  } else {
    detailsLink = `/accounts/trips/${tripId}`
  }
  const clickHandler = e => {
    let dateString = new Date(convertToSafariCompatibleDate(travelDate))
    dateString = dateString.toString()
    const clevertapData = {
      'event type': 'trip details clicked',
      platform: 'desktop',
      'booking name': tripName,
      'fulfillment time': dateString.substr(16, 5),
      'fulfillment date': dateString.substr(4, 11),
      'product name': tripType,
      trip_ID: tripId
    }
    const CommonClevertapParams = getCommonClevertapParams()
    if (tripDetails.internalUserForSupport) triggerClevertap(CLEVERTAP_EVENT_NAME, clevertapData)
    else {
      triggerClevertap('Account_UI_Action', {
        action_name: 'trip_details_click',
        domain: CommonClevertapParams.domain,
        source_page: CommonClevertapParams.source_page,
        platform: CommonClevertapParams.platform,
        trip_id: tripId,
        trip_status: bookingStatus,
        product: tripType,
        logged_id: 'Yes',
        emial_id: tripDetails && tripDetails.contactDetails && tripDetails.contactDetails.email
      })
    }
  }
  return (
    <ListItem arrow={false} enableRipple={true}>
      <a href={detailsLink} className="flag h-15" onClick={clickHandler}>
        <div className="flag__fix">
          <CalendarIcon
            travelDate={travelDate}
          />
        </div>
        <div className="flag__fix amr-15 aml-15">
          <TripTypeIcon
            tripDetails={tripDetails}
          />
        </div>
        <div className="flex-1 amr-10 flex-basis-30">
          <Truncate className="trip-title us-text" width="98%">
            {formatTripName(tripDetails)}
          </Truncate>
          <If condition={!loader}>
            <Truncate className="fs-12 lh-copy c-black-50 us-text" width="98%">
              {travellers || '--'}
            </Truncate>
          </If>
          <If condition={loader}>
            <Truncate className="fs-12 lh-copy c-black-50 us-text" width="98%" />
          </If>
        </div>
        <If condition={!loader}>
          <div className="flag__fix amr-10 h-8 tripListStatus">
            <div className={`trip-status us-text ${getStatusBgClass(bookingStatus)}`}>
              {getMappedValue(bookingStatus)}
            </div>
          </div>
          <div className="flag__fix aml-5 ta-r last-col">
            <h5 className="fs-11 lh-solid t-truncate c-black-60 us-text">
              {getMappedValue('Trip ID')}: {tripId}
            </h5>
            <Truncate
              className={
                showTrackerText(bookingStatus, bookingDate).isHighlighted ? 'us-text fs-10 c-blue fw-500 lh-copy c-black-40 amt-5' : 'us-text fs-1 lh-copy c-black-40 amt-5'}
              width="98%"
            >
              {showTrackerText(bookingStatus, bookingDate).value}
            </Truncate>
          </div>
        </If>
        <If condition={loader}>
          <div className="flag__fix amr-10 h-8" />
          <div className="flag__fix aml-5 ta-r last-col loader dotDotDot" />
        </If>
      </a>
    </ListItem>
  )
}

export default TripsListDesktopItem
